// Third party
import { ErrorPolicy } from '@apollo/client';

// Utils
import {
  ListingByExternalIdAndSourceQuery,
  ListingByExternalIdAndSourceDocument,
  ListingByExternalIdAndSourceQueryVariables,
} from '@gql';
import { createApolloClient } from '../apollo-node-client';

type Options = {
  variables: ListingByExternalIdAndSourceQueryVariables;
  errorPolicy?: ErrorPolicy;
};

export const imperativeNodeListingByExternalIdAndSourceQuery = async (
  options: Options,
  accessToken?: string
) => {
  let apolloClient = createApolloClient();

  if (accessToken) {
    apolloClient = createApolloClient(accessToken);
  }

  const response = await apolloClient.query<ListingByExternalIdAndSourceQuery>({
    ...{ query: ListingByExternalIdAndSourceDocument },
    ...options,
  });

  return { ...response, apolloClient };
};

// Union of all ListingByExternalId types
type ListingByExternalIdAndSourceQueryResults = NonNullable<
  ListingByExternalIdAndSourceQuery['listingByExternalIdAndSource']
>;

// Get the branch of the listing union that has a specific typename
type ListingByExternalIdAndSourceQueryResultsType<
  T extends ListingByExternalIdAndSourceQueryResults['__typename'],
> = ListingByExternalIdAndSourceQueryResults & { __typename: T };

export type ListingByExternalIdPartial =
  ListingByExternalIdAndSourceQueryResultsType<'Listing'>;
